import React from 'react';
import {Form} from 'react-bootstrap';
import {Dropdown} from '../../../../../../../shared/ui/Dropdown';

/**
 * Advanced mode fields: min current/power, increase/decrease type+value.
 *
 * @param {object} props
 * @param {boolean} props.usesMinPower — show minPowerW instead of minCurrent
 * @param {object} props.formData — current EV charger form data
 * @param {function} props.onChange — direct field change handler
 * @param {function} props.onIncreaseChange — nested increase.{name} change
 * @param {function} props.onDecreaseChange — nested decrease.{name} change
 */
const AdvancedFields = ({usesMinPower, formData, onChange, onIncreaseChange, onDecreaseChange}) => (
  <>
    {usesMinPower ? (
      <Form.Group>
        <Form.Label>Minimum Charging Power</Form.Label>
        <Form.Control type="number" name="minPowerW" value={formData?.minPowerW ?? ''} onChange={onChange}/>
      </Form.Group>
    ) : (
      <Form.Group>
        <Form.Label>Minimum Charging Current</Form.Label>
        <Form.Control type="number" name="minCurrent" value={formData?.minCurrent ?? ''} onChange={onChange}/>
      </Form.Group>
    )}
    <Form.Group>
      <Form.Label>Increase type</Form.Label>
      <Dropdown
        name="type"
        options={[
          {value: 'absolut', label: 'Absolute'},
          {value: 'ratio', label: 'Ratio'},
        ]}
        value={formData?.increase?.type || 'absolut'}
        onChange={onIncreaseChange}
        block
      />
      <Form.Label>Increase value</Form.Label>
      <Form.Control type="number" name="value" value={formData?.increase?.value ?? ''} onChange={onIncreaseChange}/>
    </Form.Group>
    <Form.Group>
      <Form.Label>Decrease type</Form.Label>
      <Dropdown
        name="type"
        options={[
          {value: 'absolut', label: 'Absolute'},
          {value: 'ratio', label: 'Ratio'},
        ]}
        value={formData?.decrease?.type || 'absolut'}
        onChange={onDecreaseChange}
        block
      />
      <Form.Label>Decrease value</Form.Label>
      <Form.Control type="number" name="value" value={formData?.decrease?.value ?? ''} onChange={onDecreaseChange}/>
    </Form.Group>
  </>
);

export default AdvancedFields;

